module.exports = __webpack_public_path__ + "img/流程.c2c2e50e.svg";